import { useState, useEffect, useContext, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {useTranslation} from 'react-i18next';

import ConversationOptions from './ConversationOptions';
import ConvContext from '../../../store/conversation-context';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import { fetchNpcIcon } from '../../Helpers/Conversation/ConversationInit';

const ConversationSection = (props) => {
  const section = useRef();
  const {t: translate } = useTranslation();
  const { convContext } = useContext(ConvContext);
  const location = useSelector((state) => state.location);
  const activeConversation = useSelector((state) => state.activeSection);
  const [sectionClass, updateSectionClass] = useState('conversation-section');
  const {
    sentenceNumber,
    npcSentence,
    modelAnswerSentence,
    modelAnswerSentenceNative,
    splits,
    npcMasterSentence,
  } = props.data;

  const npcIconUrl = fetchNpcIcon(location);
  const dispatch = useDispatch();
  const playNpcAudio = useSelector((state) => state.playNpcAudio);
  const [showNative, setShowNative] = useState(false);

  let npc_content = showNative === true ? npcMasterSentence : npcSentence;

  const loadingAnimation = () => {
    //Max of 5 parts per conversations
    if (parseInt(activeConversation) === 5) return;

    if (props.index > activeConversation) return;

    updateSectionClass('conversation-section conversation-section--active');

    setTimeout(function () {
      let sectionTop = activeConversation === 0 ? section.current.scrollTop : document.body.scrollHeight;
      window.scrollTo({
        left: 0,
        top: sectionTop,
        behavior: 'smooth',
      });
    }, 200);
  };

  const playAudio = () => {
    // document.querySelector('#main_audio_player').play();
    dispatch({
      type: 'playNpcAudio',
    });
  };

  useEffect(() => {
    // playAudio()
    try {
      if (activeConversation === 5) return;
      loadingAnimation();
    } catch (error) {
      console.warn("Couldn't load section");
    }
  }, []);

  //show npc part always
  //have either convo parts or full conversation showing
  return (
    <div key={props.index} className={sectionClass} ref={section}>
      <div className="npc">
        <img src={npcIconUrl} alt={`${convContext.location} NPC`} />
        <div
          className={`${
            showNative ? 'npc__text npc__text--translated' : 'npc__text'
          }`}
        >
          {activeConversation === props.index && (
            <div className="npc__actions" onClick={playAudio}>
              <FontAwesomeIcon
                icon={playNpcAudio === true ? faVolumeUp : faPlay}
                size="1x"
              />
            </div>
          )}
          <p className="npc__content">{npc_content}</p>
          {activeConversation === props.index && (
            <span
              className="npc__translate"
              onMouseDown={(e) => {
                e.stopPropagation();
                setShowNative(true);
              }}
              onTouchStart={(e) => {
                e.stopPropagation();
                setShowNative(true);
              }}
              onMouseUp={(e) => {
                e.stopPropagation();
                setShowNative(false);
              }}
              onTouchEnd={(e) => {
                e.stopPropagation();
                setShowNative(false);
              }}
              onTouchCancel={(e) => {
                e.stopPropagation();
                setShowNative(false);
              }}
              onMouseLeave={(e) => {
                e.stopPropagation();
                setShowNative(false);
              }}
            >
              {showNative ? translate('translated') : translate('translate')}
            </span>
          )}
        </div>
      </div>
      <ConversationOptions
        index={props.index}
        splits={splits}
        sentenceNumber={sentenceNumber}
        modelAnswerSentence={modelAnswerSentence}
        modelAnswerSentenceNative={modelAnswerSentenceNative}
      />
    </div>
  );
};

export default ConversationSection;
